<template>
  <main class="flex-grow w-full flex justify-center py-8 px-4">
    <div class="w-full max-w-2xl mx-auto text-center">
      <div class="bg-white rounded-lg shadow-lg p-8">
        <div class="mb-6">
          <div class="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-4">
            <svg class="w-8 h-8 text-green-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7"></path>
            </svg>
          </div>
          <h1 class="text-3xl font-bold text-gray-900 mb-2">{{ $t("thankYou.title") }}</h1>
          <p class="text-lg text-gray-600">{{ $t("thankYou.subtitle") }}</p>
        </div>

        <div v-if="invoiceNumber" class="bg-gray-50 rounded-lg p-4 mb-6">
          <p class="text-sm text-gray-600 mb-1">{{ $t("thankYou.invoiceLabel") }}</p>
          <p class="text-lg font-semibold text-gray-900">#{{ invoiceNumber }}</p>
        </div>

        <div class="space-y-4 text-left mb-8">
          <div class="flex items-start space-x-3">
            <div class="w-5 h-5 bg-green-100 rounded-full flex items-center justify-center mt-0.5">
              <svg class="w-3 h-3 text-green-600" fill="currentColor" viewBox="0 0 20 20">
                <path
                  fill-rule="evenodd"
                  d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                  clip-rule="evenodd"></path>
              </svg>
            </div>
            <p class="text-gray-700">{{ $t("thankYou.confirmationEmail") }}</p>
          </div>
          <div class="flex items-start space-x-3">
            <div class="w-5 h-5 bg-green-100 rounded-full flex items-center justify-center mt-0.5">
              <svg class="w-3 h-3 text-green-600" fill="currentColor" viewBox="0 0 20 20">
                <path
                  fill-rule="evenodd"
                  d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                  clip-rule="evenodd"></path>
              </svg>
            </div>
            <p class="text-gray-700">{{ $t("thankYou.teamContact") }}</p>
          </div>
          <div class="flex items-start space-x-3">
            <div class="w-5 h-5 bg-green-100 rounded-full flex items-center justify-center mt-0.5">
              <svg class="w-3 h-3 text-green-600" fill="currentColor" viewBox="0 0 20 20">
                <path
                  fill-rule="evenodd"
                  d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                  clip-rule="evenodd"></path>
              </svg>
            </div>
            <p class="text-gray-700">{{ $t("thankYou.projectStart") }}</p>
          </div>
        </div>

        <div class="flex flex-col sm:flex-row gap-4 justify-center">
          <a href="/" class="btn btn-primary px-6 py-2">
            {{ $t("thankYou.backToHome") }}
          </a>
          <a href="/about#contact-form" class="btn btn-outline px-6 py-2">
            {{ $t("thankYou.contactUs") }}
          </a>
        </div>
      </div>
    </div>
  </main>
</template>

<script setup lang="ts">
import { ref, onMounted } from "vue";
import { useRoute } from "vue-router";

const route = useRoute();
const invoiceNumber = ref<string | null>(null);

onMounted(() => {
  const invoice = route.query.invoice?.toString();
  if (invoice) {
    invoiceNumber.value = invoice;
  }
});
</script>
